const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const Autosuggest = require("react-autosuggest");
const URLMake = require("../../shared/URLMake");
const Link = require("../core/view/Link");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const ClassesUtil = require("./util/ClassesUtil");
const {atSchool, atUser} = require("../core/vault/StateCursors");
const OpsSchool = require("./vault/OpsSchool");
const autosuggestTheme = require("./styles/AutosuggestTheme.css");
const styles = require("./styles/UserSearch.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultUpdate(
		Component,
		(props, vaultState) => {
			const schoolState = atSchool(vaultState).get();
			return {
				user: atUser(vaultState).get(),
				schoolState,
				mainAccountLoad: OpsSchool.getAccountsLoad(schoolState),
			};
		},
		{forLoggedIn: true}
	);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "UserSearch",

		propTypes: {
			users: PT.array.isRequired, // [{id, firstName, lastName, displayName}]
			className: PT.string,
			onSelect: PT.func.isRequired,
			placeholder: PT.string,
			space: PT.string,

			// Injected by HOCs
			user: PT.object.isRequired,
			schoolState: PT.object.isRequired,
			mainAccountLoad: PT.object.isRequired,
		},

		getInitialState: function() {
			return {
				suggestions: [],
				searchVal: "",
			};
		},

		getDisplayName: function(val) {
			return _.isObject(val) ? ClassesUtil.getStudentName(val) : val;
		},

		checkInactive: function(val) {
			const {schoolState, user} = this.props;
			const {type, id} = val;
			const editableClasses = OpsSchool.getEditableClasses(
				schoolState,
				user.userID
			);
			const editableStudents = OpsSchool.getEditableStudents(
				schoolState,
				user.userID
			);

			if (type === "class") {
				return _.includes(
					editableClasses.map(c => c.id),
					id
				);
			} else if (type === "student") {
				return _.includes(
					editableStudents.map(c => c.id),
					id
				);
			}
		},

		getSuggestions: function(val) {
			const {users, space, mainAccountLoad} = this.props;

			const inputVal = val.trim().toLowerCase();
			const inputLength = inputVal.length;

			let suggestions;

			const filterInactive =
				space === "reports" && mainAccountLoad.load === "done";

			if (inputLength === 0) {
				suggestions = [];
			} else {
				suggestions = users.filter(rel => {
					const userVal = space === "modal" ? rel : rel.val;
					const displayName = _.toLower(this.getDisplayName(userVal));
					const matches = _.includes(displayName, inputVal);
					const type = rel.type;
					if (space === "accounts" || space === "modal") {
						return matches;
					} else {
						if (type === "student" || type === "class") {
							return filterInactive
								? matches && this.checkInactive(rel)
								: matches;
						} else {
							return false;
						}
					}
				});
			}
			if (space !== "modal") {
				suggestions = _.sortBy(suggestions, [
					"type",
					sug => _.toLower(this.getDisplayName(sug.val)),
				]);
			}

			// When in a modal, need to show less so all suggestions fit in modal
			const minToShow = space === "modal" ? 20 : 50;

			return suggestions.length <= minToShow ? suggestions : [];
		},

		getLink: function(suggestion) {
			const {type, id} = suggestion;
			const {space} = this.props;
			const reportMap = {
				school: URLMake.forSchoolReport(id),
				class: URLMake.forClassReport(id),
				student: URLMake.forStudentReport(id),
			};
			const accountMap = {
				school: URLMake.forSchoolAccount(id),
				class: URLMake.forClassAccount(id),
				student: URLMake.forUserAccount(id),
				staff: URLMake.forUserAccount(id),
			};
			if (space === "accounts") return accountMap[type];
			else return reportMap[type];
		},

		renderSuggestion: function(suggestion) {
			const map = {
				school: "g",
				class: "Q",
				staff: "F",
				student: "G",
			};

			if (this.props.space === "modal") {
				return (
					<span className={styles.suggestionContent}>
						{this.getDisplayName(suggestion)}
					</span>
				);
			} else {
				const icon = <span className={styles.bao}>{map[suggestion.type]}</span>;
				return (
					<Link
						className={styles.suggestionContent}
						to={this.getLink(suggestion)}
					>
						{icon}
						{" " + this.getDisplayName(suggestion.val)}
					</Link>
				);
			}
		},

		shouldRenderSuggestions(value) {
			return true;
		},

		onSuggestionSelected: function(evt, {suggestion, method}) {
			if (method === "enter") {
				if (this.props.space !== "modal") {
					this.props.onSelect(this.getLink(suggestion));
				}
			}
			if (this.props.space === "modal") {
				this.props.onSelect(suggestion);
				this.setState({searchVal: this.getDisplayName(suggestion)});
			} else {
				this.setState({searchVal: ""});
			}
		},

		getSuggestionValue: function(suggestion) {
			return this.getDisplayName(suggestion.val);
		},

		onSuggestionsFetchRequested: function(evt) {
			this.setState({suggestions: this.getSuggestions(evt.value)});
		},

		onSuggestionsClear: function() {
			this.setState({suggestions: []});
		},

		moveCursorToEnd: function(evt) {
			const temp = evt.target.value;
			evt.target.value = "";
			evt.target.value = temp;
		},

		handleSearchChange: function(evt, val) {
			const {newValue, method} = val;
			if (method === "type") {
				this.setState({searchVal: newValue});
			}
		},

		render: function() {
			const {placeholder, space} = this.props;
			const inputProps = {
				placeholder: placeholder || "Search",
				value: this.state.searchVal,
				onChange: this.handleSearchChange,
				onFocus: this.moveCursorToEnd,
			};
			const iconEl =
				space === "modal" ? null : <div className={styles.searchIcon}>b</div>;

			if (space === "modal") {
				autosuggestTheme.suggestionsContainer = styles.smallContainer;
			}
			return (
				<div className={this.props.className || styles.search}>
					<Autosuggest
						id="relationsSearch"
						theme={autosuggestTheme}
						suggestions={this.state.suggestions}
						onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
						onSuggestionsClearRequested={this.onSuggestionsClear}
						shouldRenderSuggestions={this.shouldRenderSuggestions}
						getSuggestionValue={this.getSuggestionValue}
						onSuggestionSelected={this.onSuggestionSelected}
						renderSuggestion={this.renderSuggestion}
						highlightFirstSuggestion={true}
						inputProps={inputProps}
					/>
					{iconEl}
				</div>
			);
		},
	})
);
